import { useState, useCallback } from 'react';
import axios from 'axios';

// Set a base URL for all API requests
const apiClient = axios.create({
  baseURL: 'https://f1-podium-predictor-backend.onrender.com', // Your FastAPI backend
  headers: {
    'Content-Type': 'application/json',
  }
});

export const useApi = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Function for GET requests
  const getData = useCallback(async (url) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await apiClient.get(url);
      setData(response.data);
      return response.data; // Return data on success
    } catch (err) {
      const errorMsg = err.response ? JSON.stringify(err.response.data) : err.message;
      setError({ message: errorMsg });
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Function for POST requests
  const postData = useCallback(async (url, payload) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(url, payload);
      setData(response.data);
      return response.data; // <-- *** THE FIX *** Return data on success
    } catch (err) {
      const errorMsg = err.response ? JSON.stringify(err.response.data) : err.message;
      setError({ message: errorMsg });
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { data, error, isLoading, getData, postData };
};